import { useState, useEffect } from 'react'
import { pwaUpdateStore } from '../notifications/pwa-update-store'

/**
 * React hook that exposes PWA update state.
 *
 * Returns:
 * - `needsRefresh` – true when a new SW is waiting
 * - `applyUpdate`  – reload into the new version
 */
export function usePwaUpdate() {
  const [needsRefresh, setNeedsRefresh] = useState(false)

  useEffect(() => {
    return pwaUpdateStore.subscribe(setNeedsRefresh)
  }, [])

  return {
    needsRefresh,
    applyUpdate: () => pwaUpdateStore.applyUpdate(),
  }
}
